import { render, staticRenderFns } from "./WooCommerce.vue?vue&type=template&id=8246895e"
import script from "./WooCommerce.vue?vue&type=script&lang=js"
export * from "./WooCommerce.vue?vue&type=script&lang=js"
import style0 from "./WooCommerce.vue?vue&type=style&index=0&id=8246895e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports